import { inject } from 'readuz';
import { DIReader } from './common';

export const bootstrap: DIReader<void> = inject(
    env => env.loadCxf,
    env => env.cxfProvider,
    env => env.app,
    env => env.log,
    env => env.logError,
    (loadCxf, cxfProvider, app, log, logError) => {
        log('initializing');
        loadCxf()
            .then((cxf) => {
                log('CXF has been loaded');
                cxfProvider.set(cxf);
                app();
            })
            .catch(e => logError('Cannot load CXF', e));
    },
);
